var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"no-margin"},[_vm._v("Créé "+_vm._s(_vm._f("ago")(_vm.value.createdAt)))]),_vm._v(" "),_c('p',{staticClass:"no-margin text-size-small text-muted"},[_vm._v("Modifié "+_vm._s(_vm._f("ago")(_vm.value.updatedAt)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42709f1f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue
// module id = 695
// module chunks = 17